import * as Net from 'util/Net';

export interface OnboardingSessionResult {
  session_id: string;
}

/**
 * Start or resume the onboarding question flow for the current user.
 *
 * Creates a new onboarding session if the user has never onboarded, resumes
 * an existing session that is still waiting for answers, or creates a fresh
 * session if the previous one is already complete (restart).
 */
export function startOnboardingSession(): Promise<OnboardingSessionResult> {
  return Net.postJSONPromise({
    url: '/1/api/users/me/llm-onboarding/start',
    data: {},
  });
}
